const getters = {
  userRouters: state => state.user.userRouters,
  routes: state => state.user.routes,
  sidebar: state => state.app.sidebar,
  device: state => state.app.device
};
export default getters;
